import { ReactNode } from "react";
import { ChatBubbleIcon, EnvelopeOpenIcon } from "@radix-ui/react-icons";
import { GlobeIcon } from "lucide-react";
import { Comment01Icon } from "@/v2/assets/icons/Comment01Icon";
import { SimulatorChannelIcon } from "@/routes/simulators/SimulatorChannelIcon";

export const formatString = (value: string) => {
  if (value === "autonomous_quackchat") return "Quack Chat";

  return value
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

export const channelToIcon: Record<string, ReactNode> = {
  chat: <ChatBubbleIcon width={"14"} height={"14"} />,
  native_messaging: <ChatBubbleIcon width={"14"} height={"14"} />,
  autonomous_quackchat: <Comment01Icon fill="orange" />,
  slackbot: <div style={{ marginLeft: "-3px" }}><SimulatorChannelIcon channel="slackbot" size="2" /></div>,
  web: <GlobeIcon width={"14"} height={"14"} />,
  email: <EnvelopeOpenIcon width={"14"} height={"14"} />,
};

export function ChannelFormatter({ value }: { value: string }) {
  return (
    <span className="flex items-center gap-1">
      {channelToIcon[value] ?? <EnvelopeOpenIcon width={"14"} height={"14"} />}
      {formatString(value)}
    </span>
  );
}
